﻿import React from 'react';

import CheckmarkAnimation from './CheckmarkAnimation';

import useIntersection from '../useIntersection';


const CheckmarkContainer = (props) => {

    const ref = React.useRef();
    const inViewport = useIntersection(ref, "-50px");

    const itemIds = [0, 1, 2];

    return (
        <ul className="cottage-campaign__usp__container" ref={ref}>
            {itemIds.map(i => (
                <CheckmarkAnimation
                    i={i}
                    key={i}
                    text={props.texts[i]}
                    heading={props.headings[i]}
                    inViewport={inViewport} />
            ))}
        </ul>    
     )
 }                

export default CheckmarkContainer;


